module.exports = __webpack_public_path__ + "img/Code2.9a850852.jpg";